<template>
  <div>
    <div class="body-overlay" id="body-overlay"></div>
    <SearchPopup />
    <Header />

    <div
      id="contact-page-area"
      class="contact-page-area bg-sky pd-top-120 pd-bottom-120 bg-relative"
    >
      <img
        class="left_image_bounce position-top-right"
        :src="require('@/assets/img/about/4.png')"
        alt="img"
      />
      <form ref="form" @submit="sendEmail" class="container">
        <div class="contact-page-inner">
          <div class="row justify-content-center">
            <div class="col-lg-6 pe-xl-5">
              <h3 class="mb-xl-5 mb-4">Escribe un Mensaje</h3>
              <div class="single-input-inner style-bg">
                <input type="text" placeholder="Nombre" v-model="vName" />
              </div>
              <div class="single-input-inner style-bg">
                <input
                  type="text"
                  placeholder="Telefono"
                  v-model="vPhone"
                  @input="validatePhoneNumber"
                />
                <p v-if="phoneError" class="error-message">
                  El número de teléfono debe contener 10 dígitos.
                </p>
              </div>
              <div class="single-input-inner style-bg">
                <input
                  type="text"
                  placeholder="Email"
                  v-model="vEmail"
                  @input="validateEmail"
                />
                <p v-if="!isValidEmail" class="error-message">
                  Por favor, ingrese un correo electrónico válido.
                </p>
              </div>
              <div class="single-input-inner style-bg">
                <textarea placeholder="Mensaje" v-model="vText"></textarea>
              </div>
              <div class="btn-wrap">
                <button
                  :disabled="
                    phoneError || !isValidEmail || !vPhone || !vName || !vText
                  "
                  type="submit"
                  class="btn btn-black border-radius"
                  @click="showSuccessAlert"
                >
                  Enviar
                </button>
                <br /><br />

                <b-alert variant="info" :show="send" v-if="send">{{
                  alertMessage
                }}</b-alert>
                <br />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="section-title mb-0 mt-5 mt-lg-0">
                <h6 class="sub-title">Contáctanos</h6>
                <h2 class="title">Todas tus dudas son Respondidas</h2>
                <p class="content">
                  Nos aseguramos de responderte en el menor tiempo posible.
                </p>
                <div class="media single-list-media style-3 mt-4">
                  <div class="media-left">
                    <img :src="require('@/assets/img/icon/8.png')" alt="img" />
                  </div>
                  <div class="media-body align-self-center">
                    <p>¿Tienes alguna dudas?</p>
                    <h4>+52 (668) 165-3819</h4>
                  </div>
                </div>
                <div class="media single-list-media style-3 mt-4">
                  <div class="media-left">
                    <img :src="require('@/assets/img/icon/9.png')" alt="img" />
                  </div>
                  <div class="media-body align-self-center">
                    <p>Escribenos</p>
                    <h4>contacto@smaco.biz</h4>
                  </div>
                </div>
                <div class="media single-list-media style-3 mt-4 mb-0">
                  <div class="media-left">
                    <img :src="require('@/assets/img/icon/10.png')" alt="img" />
                  </div>
                  <div class="media-body align-self-center">
                    <p>Visitanos</p>
                    <h4>
                      Calle Del Nogal 20 norte, Tabachines 1. Los Mochis,
                      Sinaloa - CP: 81257
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <Client />
    <Instagram />
    <Footer />
  </div>
</template>

<script>
import SearchPopup from "@/components/layout/SearchPopup.vue";
import Header from "@/components/layout/Header.vue";
import Client from "@/components/page/home/Client.vue";
import Instagram from "@/components/page/home/Instagram.vue";
import Footer from "@/components/layout/Footer.vue";
import Toast from "@/components/layout/Toast.vue";
import { BAlert } from "bootstrap-vue";

export default {
  name: "Contact",
  components: {
    SearchPopup,
    Header,
    Client,
    Instagram,
    Footer,
    Toast,
    BAlert
  },
  data() {
    return {
      vName: "",
      vPhone: "",
      vEmail: "",
      vText: "",
      phoneError: false,
      isValidEmail: true,
      send: false,
      alertMessage: "Correo enviado exitosamente!",
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    showSuccessAlert() {
      this.send = true;

      // Configura un temporizador para ocultar la alerta después de 3 segundos (3000 milisegundos)
      setTimeout(() => {
        this.send = false;
      }, 2800);
    },
    async sendEmail(e) {
      e.preventDefault();
      if (this.phoneError || !this.isValidEmail) {
        return;
      }

      const data = {
        name: this.vName,
        body: this.vText,
        phone: this.vPhone,
        email: this.vEmail
      };

      await fetch("https://email-api.smaco.biz/api/Email", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json" // Puedes configurar otros encabezados aquí
          // 'Authorization': 'Bearer tu-token' // Ejemplo de encabezado de autorización
        }
      });

      this.$refs.form.reset();
      (this.vName = ""),
        (this.vPhone = ""),
        (this.vEmail = ""),
        (this.vText = ""),
        (this.phoneError = false),
        (this.isValidEmail = true),
        (this.send = true);
    },

    validatePhoneNumber() {
      if (this.vPhone.length === 10) {
        this.phoneError = false;
      } else {
        this.phoneError = true;
      }
    },
    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (!emailRegex.test(this.vEmail)) {
        this.isValidEmail = false;
      } else {
        this.isValidEmail = true;
      }
    },
    validateForm() {
      return this.phoneError || !this.isValidEmail;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Contact.vue